export interface Rgba {
  r: number;
  g: number;
  b: number;
  a: number;
}

// Eight bits a channel and two decimals of alpha is all the picker holds, so it is all any notation may leave here.
export function clampRgba({ r, g, b, a }: Rgba): Rgba {
  return {
    r: Math.round(clamp(r, 0, 255)),
    g: Math.round(clamp(g, 0, 255)),
    b: Math.round(clamp(b, 0, 255)),
    a: Math.round(clamp(a, 0, 1) * 100) / 100,
  };
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, Number.isFinite(value) ? value : 0));
}
